import { render, staticRenderFns } from "./DashboardTabs.vue?vue&type=template&id=3e251925&"
import script from "./DashboardTabs.vue?vue&type=script&lang=js&"
export * from "./DashboardTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports